import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DEFAULT_CREDITS_ATTEMPTS } from '../../prize-box-page.constants';
import styles from '../../prize-box-page.module.css';
import clsx from 'clsx';

import { useCountdown } from 'modules/daily-quests-page/hooks/use-countdown';

interface ICountdownBoxProps {
  quotaResetAt: number | null;
  attempts: number;
  extraCredits: number;
}

export const CountdownBox: FC<ICountdownBoxProps> = ({ quotaResetAt, attempts, extraCredits }) => {
  const { t } = useTranslation();
  const { label } = useCountdown(quotaResetAt);
  const isBlocked = useMemo(
    () => attempts >= DEFAULT_CREDITS_ATTEMPTS && extraCredits <= 0,
    [attempts, extraCredits],
  );

  return (
    <div className="flex flex-col items-center gap-8 pb-6 pt-4 text-center">
      <div className="mx-auto w-full">
        <p className="mt-2 text-white/80">
          {isBlocked ? t('prizeBox.nextFreeChestsIn') : t('prizeBox.playNow')}
        </p>
        <div className="mt-2 flex flex-col items-center justify-center gap-4 xs:gap-6">
          <p className={clsx(styles.textYellow, 'text-center text-5xl xs:text-6xl')}>
            {label.split('').map((char, i) => (
              <span key={i} className="inline-block w-[1ch] text-center">
                {char}
              </span>
            ))}
          </p>
          <p className="text-md font-semibold leading-4 text-white-text/75">
            {t('prizeBox.dailyChestsLeft')}: {Math.min(attempts, DEFAULT_CREDITS_ATTEMPTS)}
          </p>
        </div>
      </div>
    </div>
  );
};
